import { styled } from '@mui/system'
import BHTabs from '../../../molecules/tabs'

const Tabs = styled(BHTabs)`
	.MuiTabs-scroller {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100%;
	}
	.MuiTabs-flexContainer {
		width: 100%;
		justify-content: center;
		border-bottom: 1px solid ${({ theme }) => theme.palette.grey.light};
		.MuiTab-root {
			flex: 1 0 50%;
			${({ theme }) => theme.breakpoints.up('md')} {
				flex: inherit;
				min-width: 220px;
			}
		}
	}
	+ .MuiTabs-indicator {
		height: 1px;
	}
`

export { Tabs }
